import { SearchNormal1, TruckTime, Verify } from "iconsax-react";
import React, { useEffect, useState } from "react";
import Modal from "../component.js/Modal";
import { LSSB } from "../utils/LSSB_live";
import { useQuery } from "@tanstack/react-query";
import { ClipLoader, PropagateLoader } from "react-spinners";
import { Link, useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import Lottie from "react-lottie";
import animationData from "../assets/empty.json";

const Grants = () => {
  const navigate = useNavigate();
  const [state, setState] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isLevelOpen, setIsLevelOpen] = useState(false);
  const [awardName, setAwardName] = useState("");
  const [isProject, setIsProject] = useState(false);
  const [isProjectCheck, setIsProjectCheck] = useState(false);
  const [page, setPage] = useState("1");
  const [levels, setLevels] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState("");
  const [isPaidNotice, setIsPaidNotice] = useState(false);
  const [isProceedPayment, setProceedPayment] = useState(false);
  const [invoice, setInvoice] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPaymentRequest, setIsPaymentRequest] = useState(false);
  const [isApplSuccess, setIsApplySuccess] = useState(false);
  const [grantDetails, setGrantDetails] = useState(null);
  const [isCofirming, setIsConfirming] = useState(false);
  const [isRequestSuccess, setIsRequestSuccess] = useState(false);
  const [payerId, setPayerId] = useState("");
  const [pin, setPin] = useState("");
  const [payRef, setPayRef] = useState("");
  const [payLink, setPayLink] = useState("");

  const handleCloseModal = () => {
    setIsOpen(false);
  };
  const handleCloseProjcet = () => {
    setIsProject(false);
  };
  const handleCloseProjcetChecked = () => {
    setIsProjectCheck(false);
  };

  let userData = sessionStorage.getItem("lssbAdminData");
  userData = JSON.parse(userData);

  // //console.log("userData======>>>>", userData);
  // @@ -- Fetch Grants
  const fetchGrants = async (page) => {
    let res = await LSSB.make_API_call({
      _endpoint: "fetch_grants",
      $k: userData?.token,
      $page: 1,
      $items_per_page: 10, // or 10 default,
    });
    return res;
    // //console.log("grants rsss=====>>>", res);
  };
  const grantQuery = useQuery(["g", page], () => fetchGrants(page));

  const handleSearch = (e) => {
    e.preventDefault();
    setPage("1");
    setSearchTerm(e.target.value);
  };

  const fetchProfile = async (page) => {
    let res = await LSSB.make_API_call({
      $k: userData.token,
      _endpoint: "fetch_users",
      $where: { _id: "$self" },
    });

    return res;
  };

  const profileQuery = useQuery(["profile"], () => fetchProfile());
  // //console.log("grants rsss=====>>>", profileQuery?.data?.data?.data?.invoices);

  let invoices = profileQuery?.data?.data?.data?.invoices || [];

  const resultArray = Object.keys(invoices).map((key) => ({
    key, // Preserve the original key (like 'lagos_state_bursary', 'random_test')
    ...invoices[key], // Spread the inner object properties
  }));

  const fetchApplications = async (page) => {
    let res = await LSSB.make_API_call({
      _endpoint: "fetch_applications",
      $k: userData.token,
      $page: 1,
      $items_per_page: 10, // or 10 default,
      $join: {
        // @@ aggregate data from another collection (or table in SQL terms)
        collection: "applicants",
        id_key: "_fields.applicant_id", // @@ id_key on this data to aggregate on the $join collection, applicant_id in this case
      },
      $where: {},

      $where: {
        "_fields.applicant_id": userData.user?._id,
        "_fields.application_status": state,
      },
      // $items_per_page: 10 -- default is 10
    });
    return res;
  };
  const ApplicationQuery = useQuery(["g", page, state], () =>
    fetchApplications(page)
  );
  const Applications = ApplicationQuery?.data?.data?.data || [];

  const lastApplication = Applications[0];

  function isCurrentYear(dateString) {
    const inputDate = new Date(dateString);
    const currentYear = new Date().getFullYear();

    return inputDate.getFullYear() === currentYear;
  }

  const handleApply = (item) => {
 
    if (isCurrentYear(lastApplication?.Date_Applied)) {
      enqueueSnackbar(
        `You cannot apply for another award, you applied for ${lastApplication?.Grant} this year `,
        { variant: "error" }
      );
      return
    }
    
    setGrantDetails(item);

    if (
      item?._fields.grant_access_mode === "pin" &&
      item?._fields.grant_name !== "Special Scholarship for Development"
    ) {
      setAwardName(item?._fields.grant_name);
      setIsOpen(true);
    }

    if (item?._fields.grant_access_mode === "paid") {
      const isValueSuccess = resultArray.some(
        (tem) =>
          tem.grant_name === item?._fields?.grant_name &&
          tem.pay_status === "success"
      );

      if (isValueSuccess) {
        // //console.log("invoce Pending", isValuePending);
        navigate("/register", {
          state: { grantInfo: grantDetails, eduLevel: selectedLevel },
        });
        return;
      }
      setIsLevelOpen(true);
      setAwardName(item?._fields.grant_name);
      setLevels(item?._fields.grant_level);
    }

    if (item?._fields.grant_access_mode === "free") {
      setIsLevelOpen(true);
      setAwardName(item?._fields.grant_name);
      setLevels(item?._fields.grant_level);
    }
    if (item?._fields.grant_name === "Special Scholarship for Development") {
      setIsProject(true);
    }
  };
  const handcloseleLevel = () => {
    // setSelectedLevel("");
    setIsLevelOpen(false);
  };

  const handleOpenInvoice = () => {
    getPayRefference();
  };

  function closePaymentPortal() {
    setInvoice(false);
    setIsPaymentRequest(false);
    setIsRequestSuccess(false);
  }

  LSSB.award_edu_cost = {
    bursary: {
      Undergraduate: 2500,
      "Law School": 4000,
      Maritime: 4000,
      test_: 100000000000000, // for live test
    },

    scholarship: {
      // 'Secondary School': 3000,
      Undergraduate: 3500,
      Masters: 4000,
      "P.H.D": 5000,
      // 'Law School': 5000,
      // 'Maritime Academy': 5000,
      // 'Law School': 50000000, // so it's unpayable - should it be bypassed
      // 'Maritime Academy': 50000000, // so it's unpayable - should it be bypassed
      // 'test_': xConfig.mode !== 'test' ? 100000000000000 : 100, // for live test
    },

    // compassionate_scholarship: {

    // }
  };

  const grantFee = (level) => {
    if (grantDetails?._fields.grant_type_code === "LSB") {
      const grantTypeFee = LSSB.award_edu_cost?.bursary;
      const fee = getKeyByValue(grantTypeFee, level);

      // //console.log("thefee--->>>", fee);
      return fee;
    } else {
      const grantTypeFee = LSSB.award_edu_cost?.scholarship;
      const fee = getKeyByValue(grantTypeFee, level);

      // //console.log("thefee--->>>", fee);
      return fee;
    }
  };

  // //console.log("user fee====>>>", grantFee(selectedLevel));

  const LSSS_months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let currDate = new Date();
  let currentISODate = new Date().toISOString(); // Gets ISO format of the date
  let slicedISODate = currentISODate.slice(0, 4);
  const invoiceNumber = `${
    "" + slicedISODate + userData?.user?._fields?.username
  }`;

  function getKeyByValue(object, value) {
    // Iterate over the object's keys
    return object[value];
    // Return null if no key with the given value is found
  }

  const myInvoiceVar = {
    title: "Invoice", // Receipt upon confirmation
    grant_type: grantDetails?._fields.grant_type,
    grant_name: grantDetails?._fields.grant_name,
    edu_level: selectedLevel, // undergraduate etc.. based on selection
    pay_amount: grantFee(selectedLevel),
    invoice_num: invoiceNumber,
    // do your thing.. maybe concat a slice of current timestamp+username `${""+Date.now()).slice(6)-${username.splice(0,4)}`; for uniqueness.. Admin might need to do a $query by invoice number if payment issues arise later on.
    // pay_ref: "92353500-4447217-520", // -- later
    payment_date: "null",
    pay_status: "pending", // pending, Paid,
    invoice_date:
      currDate.getDate() +
      "-" +
      LSSS_months[currDate.getUTCMonth()].slice(0, 3) +
      "-" +
      currDate.getFullYear(),
  };

  const convertDateFormat = (inputDate) => {
    // Split the input date by '-'
    const [day, month, year] = inputDate.split("-");

    // Create a new Date object
    const date = new Date(`${year}-${month}-${day}`);

    // Define month names
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Extract day, month, and last 2 digits of the year
    const dayFormatted = parseInt(day);
    const monthFormatted = monthNames[date.getMonth()];
    const yearFormatted = year.slice(2); // Last 2 digits of the year

    // Return formatted date
    return `${dayFormatted}-${monthFormatted}-${yearFormatted}`;
  };
  const handlePaymentNotify = () => {
    if (grantDetails?._fields.grant_access_mode === "paid") {
      setIsPaidNotice(true);
    } else if (grantDetails?._fields.grant_access_mode === "free") {
      navigate("/register", {
        state: { grantInfo: grantDetails, eduLevel: selectedLevel },
      });
    }
  };
  const generatPayerId = async () => {
    setIsLoading(true);

    try {
      let res = await LSSB.make_API_call({
        $k: userData?.token,
        _endpoint: "get_payerid",
        isPayment: true,

        type: "N",
        title: userData?.user?._fields?.sex === "Male" ? "Mr/Ms." : "Miss/Mrs",
        lastName: userData?.user?._fields?.lastname, // split fullname index 0
        firstName: userData?.user?._fields?.middleName, // split fullname index 1
        Phone: userData?.user?._fields.phone_no,
        dateOfBirth: convertDateFormat(userData?.user?._fields.dob), // --- in this format :: -> "13-November-19",
        email: userData?.user?._fields.email,
        address: userData?.user?._fields.address,
      });
      if (res?.success === true) {
        setPayerId(res?.data?.payer_id);
        setIsLoading(false);
        setIsPaidNotice(false);
        handcloseleLevel();
        setProceedPayment(true);
      } else {
        setIsLoading(false);
        enqueueSnackbar("Error generating Payer ID", { variant: "error" });
      }
    } catch (error) {}
  };

  const getPayRefference = async () => {
    setIsLoading(true);

    try {
      let res = await LSSB.make_API_call({
        $k: userData?.token,
        _endpoint: "get_pay_ref",
        isPayment: true,

        Pid: payerId, // response_from_get_payerid_call.data.payer_id --  // from get_payerid call
        Amount: grantFee(selectedLevel), // -- from Amount selection
        grant_type: grantDetails?._fields.grant_type, // lagos_state_scholarship
        AppliedDate:
          currDate.getDate() +
          "-" +
          LSSS_months[currDate.getUTCMonth()].slice(0, 3) +
          "-" +
          currDate.getFullYear(), // current date
      });

      if (res?.success === true) {
        setPayLink(res?.data?.payment_link);
        setPayRef(res?.data?.payment_ref);
        setProceedPayment(false);
        setInvoice(true);

        setIsLoading(false);
        enqueueSnackbar("Success", { variant: "success" });
      } else {
        setIsLoading(false);
        enqueueSnackbar("Error generating Payment Refference", {
          variant: "error",
        });
      }
    } catch (e) {}
  };

  let payload = {
    $k: userData?.token,
    _endpoint: "update_user",
    _id: userData?.user?._id,
  };

  payload[`invoices.${grantDetails?._fields.grant_type}.pay_link`] = payLink;
  payload[`invoices.${grantDetails?._fields.grant_type}.pay_ref`] = payRef;
  payload[`invoices.${grantDetails?._fields.grant_type}.edu_level`] =
    selectedLevel;
  payload[`invoices.${grantDetails?._fields.grant_type}.invoice_num`] =
    invoiceNumber;
  payload[`invoices.${grantDetails?._fields.grant_type}.invoice_date`] =
    currDate.getDate() +
    "-" +
    LSSS_months[currDate.getUTCMonth()].slice(0, 3) +
    "-" +
    currDate.getFullYear();
  payload[`invoices.${grantDetails?._fields.grant_type}.pay_amount`] =
    grantFee(selectedLevel);
  payload[`invoices.${grantDetails?._fields.grant_type}.grant_name`] =
    myInvoiceVar?.grant_name;
  payload[`invoices.${grantDetails?._fields.grant_type}.payment_date`] = "null";
  payload[`invoices.${grantDetails?._fields.grant_type}.pay_status`] =
    "pending";

  const UpdateUser = async () => {
    //setIsLoading(true);

    try {
      let res = await LSSB.make_API_call(payload);

      setIsPaymentRequest(true);

      setTimeout(() => {
        setIsPaymentRequest(false);
        setIsRequestSuccess(true);
        enqueueSnackbar("Payment Processing Complete", {
          variant: "success",
        });
      }, 5000);
      setIsLoading(false);

      setIsLoading(false);
      enqueueSnackbar("Success", { variant: "success" });
    } catch (e) {
      setIsLoading(false);
      enqueueSnackbar("Error generating Payment Refference", {
        variant: "error",
      });
    }
  };

  const validatePin = async () => {
    setIsLoading(true);

    try {
      let res = await LSSB.make_API_call({
        $k: userData?.token,
        _endpoint: "use_pin",
        pin: pin,
        users_name: userData?.user?._fields?.fullname,
        users_id: userData?.user?._id,
      });

      enqueueSnackbar("Pin Validated successfully", { variant: "success" });
      setIsLoading(false);
      navigate("/register", {
        state: { grantInfo: grantDetails, eduLevel: selectedLevel },
      });
    } catch (e) {
      enqueueSnackbar("Error generating Pay Ref", { variant: "error" });
    }
  };
  const getPayRef = async () => {
    setIsLoading(true);

    try {
      let res__ = await LSSB.make_API_call({
        $k: userData?.token,
        _endpoint: "get_pay_ref",
        isPayment: true,

        Pid: payerId, // from first call
        Amount: grantFee(selectedLevel), // -- from invoice selection
        grant_type: grantDetails?._fields.grant_type,
        AppliedDate:
          currDate.getDate() +
          "-" +
          LSSS_months[currDate.getUTCMonth()].slice(0, 3) +
          "-" +
          currDate.getFullYear(), // should come from _invoice.date
      });
    } catch (e) {
      setIsLoading(false);
      enqueueSnackbar("Error generating Payer ID", { variant: "error" });
    }
  };

  const handleConfirmPayment = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      navigate("/register", {
        state: { grantInfo: grantDetails, eduLevel: selectedLevel },
      });
      enqueueSnackbar("Payment Confirmed successfully", {
        variant: "success",
      });
      setIsConfirming(true);
    }, 3000);
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  return (
    <div>
      <div className=" p-[18px] md:p-[24px] xl:p-[32px] ">
        <div className="mb-[24px]">
          <h2 className="text-[18px] md:text-[22px] xl:text-[24px] font-normal leading-[35px] text-[#25324B] mb-1 ">
            All Awards
          </h2>
          <p className="text-[#25324B] text-md md:text-lg  ">
            Showing {grantQuery?.data?.data?.data && grantQuery?.data?.data?.data?.length} results
          </p>
        </div>

        <ul className="flex items-center gap-[20px] md:gap-[32px] border-b border-[#7C8493] mb-[42px]">
          <button
            onClick={() => {
              setState("Employee");
              setSearchTerm("");
            }}
          >
            <li
              className={`py-[10px] text-[14px] ${
                state === "Employee"
                  ? "font-medium text-[#000] border-b-[2.4px]"
                  : "font-normal text-[#667185]"
              }  flex items-center justify-between border-b-[#AF8544]`}
            >
              <div className="">
                <p className="">All ({grantQuery?.data?.data?.data?.length})</p>
              </div>
            </li>
          </button>
          <button
            onClick={() => {
              setState("scholarship");
              setSearchTerm("scholarship");
            }}
          >
            <li
              className={`py-[10px] text-[14px] ${
                state === "scholarship"
                  ? "font-medium text-[#000] border-b-[2.4px]"
                  : "font-normal text-[#667185]"
              }  flex items-center justify-between border-b-[#AF8544]`}
            >
              <div className="">
                <p className="">Scholarship</p>
              </div>
            </li>
          </button>
          <button
            onClick={() => {
              setState("bursary");
              setSearchTerm("bursary");
            }}
          >
            <li
              className={`py-[10px] text-[14px] ${
                state === "bursary"
                  ? "font-medium text-[#000] border-b-[2.4px]"
                  : "font-normal text-[#667185]"
              }  flex items-center justify-between border-b-[#AF8544]`}
            >
              <div className="">
                <p className="">Bursary</p>
              </div>
            </li>
          </button>

          <button
            onClick={() => {
              setState("grant");
              setSearchTerm("grant");
            }}
          >
            <li
              className={`py-[10px] text-[14px] ${
                state === "grant"
                  ? "font-medium text-[#000] border-b-[2.4px]"
                  : "font-normal text-[#667185]"
              }  flex items-center justify-between border-b-[#AF8544]`}
            >
              <div className="">
                <p className="">Grant </p>
              </div>
            </li>
          </button>
        </ul>

        {(!grantQuery?.data?.data?.data ||
          grantQuery?.data?.data?.data.filter((result) =>
            result._fields?.grant_name
              .toLowerCase()
              .includes(searchTerm.toLowerCase())
          ).length === 0) && (
          <div className="h-[80vh] w-full flex justify-center items-center">
            <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg max-w-[420px] w-full md:max-w-[520px] 2xl:max-w-[580px] mx-auto">
              <Lottie options={defaultOptions} height={200} width={200} />
              <p className="text-base md:text-lg  font-medium text-[#515B6F] text-center mt-3 ">
                No Award available
              </p>
              <p className="text-base md:text-lg  font-medium text-[#515B6F] mt-4  text-center">
                check back later!{" "}
              </p>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {grantQuery?.data?.data?.data &&
            grantQuery?.data?.data?.data
              .filter((result) =>
                result._fields?.grant_name
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
              )
              .map((item, index) => (
                <div className="border border-[#D6DDEB] rounded-lg p-[10px] md:p-[16px] ">
                  <img
                    src="./asset/lssbLogo.png"
                    alt="logo"
                    className="h-[40px] w-[40px] md:h-[60px] md:w-[60px] mb-2"
                  />
                  <p className="text-base md:text-[18px] font-medium mb-3 text-[#25324B]">
                    {item?._fields?.grant_name}
                  </p>

                  <p className="text-sm md:text-[16px]  font-semibold text-[#25324B]  ">
                    Criteria :
                  </p>
                  <ul>
                    <li className="text-sm md:text-[14px]  font-normal text-[#515B6F]  ">
                      <span className="font-semibold text-[#25324B]">
                        1. Indigene -
                      </span>{" "}
                      The applicant must be a Bonafide indigene of Lagos State
                      (by paternity).
                    </li>
                    <li className="text-sm md:text-[14px]  font-normal text-[#515B6F]  ">
                      <span className="font-semibold text-[#25324B]">
                        2. Valid Student -
                      </span>{" "}
                      The applicant must have gained full time admission into a
                      tertiary Institution.
                    </li>
                  </ul>

                  <ul className="flex flex-wrap items-center gap-2 mt-4 mb-4">
                    {item?._fields?.grant_level &&
                      item?._fields?.grant_level.map((detail) => (
                        <li
                          key={detail.id}
                          className="text-sm md:text-[14px] border border-[#AF8544] rounded-xl py-[6px] text-[#AF8544] px-2  "
                        >
                          {detail}
                        </li>
                      ))}
                  </ul>
                  {item?._fields?.grant_status === "close" ? (
                    <button
                      // onClick={() => {
                      //   handleApply(item);
                      // }}
                      disabled
                      className="w-full cursor-not-allowed  py-[8px] md:py-[10px] bg-white border border-red-300 text-center "
                    >
                      <p className="text-red-400 text-md md:text-lg  ">
                        Closed
                      </p>
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        handleApply(item);
                      }}
                      className="w-full  py-[8px] md:py-[10px] bg-[#AF8544] hover:bg-opacity-70 text-center "
                    >
                      <p className="text-white text-md md:text-lg  ">
                        {resultArray.some(
                          (tem) =>
                            tem.grant_name === item?._fields?.grant_name &&
                            tem.pay_status === "success"
                        )
                          ? "Continue Registration"
                          : "Apply"}
                      </p>
                    </button>
                  )}
                </div>
              ))}
        </div>
      </div>

      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[550px] ">
          <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[16px] md:mb-[20px] ">
            Pin Required !
          </h2>
          <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F] mb-[24px]  ">
            Kindly enter a valid registration PIN to apply for the {awardName}
          </p>

          <input
            type="text"
            placeholder=" Enter Pin"
            className="mb-[24px] w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
            required
            autoComplete="on"
            name=""
            value={pin}
            onChange={(e) => {
              setPin(e.target.value);
            }}
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck="false"
          />

          <button
            onClick={() => {
              setIsLoading(true);
              validatePin();
              // setTimeout(() => {
              //   setIsApplySuccess(true);
              //   handleCloseModal();
              //   setIsLoading(false);
              // }, 2000);
            }}
            className="w-full mb-4  py-[8px] md:py-[10px] bg-[#AF8544] flex justify-center gap-2 "
          >
            <p className="text-white text-md md:text-lg  ">Validate Pin</p>{" "}
            {isLoading && <ClipLoader color={"white"} size={20} />}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={isApplSuccess}
        onClose={() => {
          setIsApplySuccess(false);
        }}
      >
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[550px] ">
          <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg">
            <Verify color={"#AF8544"} size={48} className="mt-6 mx-auto mb-6" />
            {/* <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[16px] md:mb-[20px] ">
              You have successfully applied for {awardName}
            </h2> */}
            <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[16px] md:mb-[20px] ">
              Pin verified successfully !!!
            </h2>
            <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F]   ">
              You are now eligible to apply for the {awardName}
            </p>

            <button
              onClick={handleConfirmPayment}
              className="w-full  py-[8px] md:py-[10px] bg-[#AF8544] text-center mt-6 md:mt-7"
            >
              <p className="text-white text-md md:text-lg  ">
                Continue Registration
              </p>
            </button>
            {/* </Link> */}
          </div>
        </div>
      </Modal>

      <Modal isOpen={isProject} onClose={handleCloseProjcet}>
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[450px] ">
          <h2 className="text-[18px] md:text-[18px] xl:text-[20px] text-center font-normal leading-[35px] text-black mb-[16px] md:mb-[20px] ">
            Is your project topic one that will impact development in lagos
            state?
          </h2>

          <div className="flex flex-wrap gap-4 justify-between mt-9">
            <button
              onClick={() => {
                handleCloseProjcet();
              }}
              className="w-[35%]   py-[6px] md:py-[8px] bg-[#AF8544] text-center "
            >
              <p className="text-white text-md md:text-lg  ">No</p>
            </button>

            <button
              onClick={() => {
                setIsProjectCheck(true);
                setIsProject(false);
              }}
              className="w-[35%]  py-[8px] md:py-[10px] bg-[#AF8544] text-center "
            >
              <p className="text-white text-md md:text-lg  ">Yes</p>
            </button>
          </div>
        </div>
      </Modal>

      <Modal isOpen={isLevelOpen} onClose={() => handcloseleLevel()}>
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[550px] ">
          <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[16px] md:mb-[20px] ">
            Choose Education Type
          </h2>

          <div className="flex justify-center gap-[20px] flex-wrap">
            {levels.map((level) => (
              <button
                onClick={() => setSelectedLevel(level)}
                className={`px-[10px] md:px-[16px] rounded-md py-[8px] md:py-[10px] border ${
                  level === selectedLevel
                    ? " border-[#AF8544]"
                    : "border-[#D6DDEB]"
                }   `}
              >
                {" "}
                <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F]   ">
                  {level}
                </p>
              </button>
            ))}
          </div>

          {isPaidNotice && (
            <div className="mt-3 md:mt-5">
              <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F]   ">
                You are required to pay a fee before commencing registration for
                this Award
              </p>
              <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F] mt-2">
                Click the button below to do so now.
              </p>
              <div className="flex items-center  gap-[20px]">
                {" "}
                <button
                  onClick={() => {
                    setIsPaidNotice(false);
                  }}
                  className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] text-center "
                >
                  <p className="text-white text-md md:text-lg  ">cancel</p>
                </button>
                <button
                  onClick={() => {
                    generatPayerId();
                  }}
                  className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] text-center   flex items-center justify-center gap-2"
                >
                  <p className="text-white text-md md:text-lg  ">
                    Proceed Payment
                  </p>
                  {isLoading && <ClipLoader color={"white"} size={20} />}
                </button>
              </div>
            </div>
          )}

          {!isPaidNotice && (
            <div className="flex items-center  gap-[20px]">
              <button
                onClick={() => {
                  handcloseleLevel();
                }}
                className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] text-center "
              >
                <p className="text-white text-md md:text-lg  ">Cancel</p>
              </button>
              <button
                onClick={() => {
                  if (!selectedLevel) {
                    enqueueSnackbar("Please select an academic leve", {
                      variant: "error",
                    });

                    return;
                  }
                  handlePaymentNotify();
                }}
                className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] text-center "
              >
                <p className="text-white text-md md:text-lg  ">Continue</p>
              </button>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        isOpen={invoice}
        onClose={() => {
          closePaymentPortal();
        }}
      >
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[500px] md:max-w-[550px] ">
          <h2 className="text-[18px] md:text-[18px] xl:text-[20px]  font-medium leading-[35px] text-black mb-[24px] ">
            Payment Portal
          </h2>
          {!isPaymentRequest && !isRequestSuccess && (
            <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg">
              <ul>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center">
                  {" "}
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    Invoice
                  </p>
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    #{myInvoiceVar?.invoice_num}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-2">
                  {" "}
                  <p className="text-md md:text-base  font-medium text-[#515B6F] ">
                    Date:
                  </p>
                  <p className="text-md md:text-base  font-normal text-[#515B6F] ">
                    {myInvoiceVar?.invoice_date}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-2">
                  {" "}
                  <p className="text-md md:text-base  font-medium text-[#515B6F] ">
                    Billed TO:
                  </p>
                  <p className="text-md md:text-base  font-normal text-[#515B6F] ">
                    {userData?.user?._fields?.fullname}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-2">
                  {" "}
                  <p className="text-md md:text-base  font-medium text-[#515B6F] ">
                    Payment For:
                  </p>
                  <p className="text-md md:text-base  font-normal text-[#515B6F] ">
                    {myInvoiceVar?.grant_name}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-2">
                  {" "}
                  <p className="text-md md:text-base  font-medium text-[#515B6F] ">
                    Education Level:
                  </p>
                  <p className="text-md md:text-base  font-normal text-[#515B6F] ">
                    {myInvoiceVar?.edu_level}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-3">
                  {" "}
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    Total Due
                  </p>
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    ₦ {myInvoiceVar?.pay_amount}
                  </p>
                </li>
              </ul>
              <div className="flex items-center  gap-[20px]">
                <button
                  onClick={() => {
                    closePaymentPortal();
                  }}
                  className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] text-center "
                >
                  <p className="text-white text-md md:text-lg  ">Pay Later</p>
                </button>
                <button
                  onClick={() => {
                    UpdateUser();
                  }}
                  className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] flex items-center justify-center gap-2 "
                >
                  <p className="text-white text-md md:text-lg  ">
                    Process Payment
                  </p>{" "}
                  {isLoading && <ClipLoader color={"white"} size={20} />}
                </button>
              </div>
            </div>
          )}
          {isPaymentRequest && (
            <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg">
              <div className="flex justify-center mt-3 mb-6">
                {" "}
                <PropagateLoader color={"#AF8544"} size={20} />
              </div>

              <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[24px] ">
                Processing Payment Request
              </h2>
              <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F] mt-4 md:mt-6">
                please hold on..
              </p>

              <p className="text-md md:text-[16px] text-center   font-medium text-[#515B6F] mt-4 md:mt-6">
                Sorting Payer ID
              </p>
              <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F] mt-4 md:mt-6">
                Generating Payment reference
              </p>
            </div>
          )}

          {isRequestSuccess && (
            <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg">
              <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[24px] ">
                Payment Processing Complete
              </h2>
              <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F] mt-4 md:mt-6">
                Click the button below to complete payment in a new window
              </p>
              <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F] mt-4 md:mt-6">
                Return to confirm your payment after you've done so
              </p>

              <div className="flex items-center justify-between mb-6 md:mb-9 ">
                <button
                  onClick={() => {
                    closePaymentPortal();
                  }}
                  className="w-[30%]  mt-8  py-[8px] md:py-[10px] border border-[#AF8544] text-center "
                >
                  <p className="text-[#515B6F] text-md md:text-lg  ">
                    Save & Pay later
                  </p>
                </button>
                <Link
                  to={payLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-[30%]"
                >
                  <button className="w-full  mt-8  py-[8px] md:py-[10px] bg-[#AF8544] flex items-center justify-center gap-2 ">
                    <p className="text-white text-md md:text-lg  ">Pay Now</p>{" "}
                  </button>
                </Link>
              </div>
              <button
                onClick={handleConfirmPayment}
                className="w-full    py-[8px] md:py-[10px] bg-[#aa5533] text-center flex justify-center items-center "
              >
                <p className="text-white text-md md:text-lg  ">
                  Confirm Payment
                </p>
                {isLoading && (
                  <ClipLoader color={"white"} size={20} className="ml-2" />
                )}
              </button>
            </div>
          )}
        </div>
      </Modal>

      <Modal isOpen={isProceedPayment} onClose={() => setProceedPayment(false)}>
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[500px] md:max-w-[550px] ">
          <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[24px] ">
            Welcome to the LSSB Online Payment Portal
          </h2>

          <p className="text-sm md:text-[14px]  font-normal text-[#515B6F] mt-4 md:mt-6">
            You're about to process payment for{" "}
            <span className="px-2 py-1 bg-[#AF8544] text-white">
              {awardName}
            </span>{" "}
            Registration
          </p>
          <p className="text-sm md:text-[14px]  font-normal text-[#515B6F] mt-2">
            You will be able to begin Registration once payment has been
            successfully received.
          </p>
          <div className="border border-[#ee6565]  bg-[#e8afaf] px-2 py-1 mt-2">
            {" "}
            <p className="text-sm md:text-[14px]  font-normal text-[#515B6F] ">
              Close this portal if you wish to process payment for another Award
              catgeory instead
            </p>
          </div>

          <div className="flex items-center  gap-[20px]">
            <button
              onClick={() => {
                setProceedPayment();
              }}
              className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] text-center "
            >
              <p className="text-white text-md md:text-lg  ">Cancel</p>
            </button>
            <button
              onClick={() => {
                handleOpenInvoice();
              }}
              className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] flex items-center justify-center gap-2 "
            >
              <p className="text-white text-md md:text-lg  ">Create invoice</p>{" "}
              {isLoading && <ClipLoader color={"white"} size={20} />}
            </button>
          </div>
        </div>
      </Modal>

      <Modal isOpen={isProjectCheck} onClose={handleCloseProjcetChecked}>
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[550px] ">
          <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[24px] ">
            Upload File
          </h2>

          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Upload project topic sign off from ypur project supervisor
            </label>
            <div className=" ">
              <input
                type="file"
                placeholder=" Enter course of study"
                className="w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                accept=".pdf,.doc,.docx"
                autoComplete="on"
                name="address"
                // value={idNumber}
                // onChange={(e) => {setIdNumber(e.target.value);}}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Upload Accounting officer sign off from the ministry that the
              project will impact.
            </label>
            <div className=" ">
              <input
                type="file"
                placeholder=" Enter course of study"
                className="w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                accept=".pdf,.doc,.docx"
                autoComplete="on"
                name="addres"
                // value={idNumber}
                // onChange={(e) => {setIdNumber(e.target.value);}}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>
          <button
            onClick={() => {
              handleCloseProjcetChecked();
              setIsLevelOpen(true);
              setLevels(grantDetails?._fields.grant_level);
            }}
            className="w-full mb-4  py-[8px] md:py-[10px] bg-[#AF8544] text-center "
          >
            <p className="text-white text-md md:text-lg  ">Continue</p>
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Grants;
